<template>
    <div class="wechat_order_wrap">
        <div class="wechat_order_top">
            <div class="wechat_order_tab">
                <ul>
                    <li
                            @click="handleClickTab(item)"
                            :class="item.name == activeName ? 'active' : ''"
                            v-for="item in tabList"
                            v-text="item.label"
                    ></li>
                </ul>
            </div>
        </div>
        <div class="wechat_order_bottom">
            <div v-if="activeName === 'order'">
                <orderManagement ></orderManagement>
            </div>
            <div v-if="activeName === 'consume'">
                <consumeManagement ></consumeManagement>
            </div>
        </div>
    </div>
</template>
<script>
import orderManagement from "./orderManagement";
import consumeManagement from "./consumeManagement";
export default {
    name: "WeChatOrder",
    components: {
        orderManagement,
        consumeManagement,
    },
    data() {
        return {
            activeName: "order",
            tabList: [
                { name: "order", label: "订单记录" },
                { name: "consume", label: "核销记录" },
            ],
        };
    },
    mounted() {
        // this.$route.meta.admin.permission = true;
    },
    methods: {
        handleClickTab(item) {
            this.activeName = item.name;
        },

    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/wechat.scss";
</style>
